module.exports = __webpack_public_path__ + "03a4ec5831da6ab5e7a4abe7d767dedb.png";